'use strict';

var ScheduleEvents = function ScheduleEvents() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // { loading: boolean, numberOfListeners: number, data: {}, info: {date, uid}}
  action = arguments[1];

  switch (action.type) {
    case 'SCHEDULE_START_SYNCING_EVENT':
      {
        var newState = Object.assign({}, state);
        addEvent(newState, action.eventId);
        if (action.dateStr) {
          addEvent(newState, action.eventId, action.dateStr);
        }
        return newState;
      }

    case 'SCHEDULE_STOP_SYNCING_EVENT':
      {
        var _newState = Object.assign({}, state);
        removeEvent(_newState, action.eventId);
        if (action.dateStr) {
          removeEvent(_newState, action.eventId, action.dateStr);
        }

        return _newState;
      }

    default:
      return state;
  }
};

var addEvent = function addEvent(state, eventId, dateStr) {
  var combinedId = eventId + (dateStr ? '->' + dateStr : '');

  if (state[combinedId]) {
    var newInfo = Object.assign({}, state[combinedId]);
    newInfo.numberOfListeners++;
    state[combinedId] = newInfo;
  } else {
    state[combinedId] = {
      numberOfListeners: 1,
      dateStr: dateStr,
      eventId: eventId
    };
  }
};

var removeEvent = function removeEvent(state, eventId, dateStr) {
  var combinedId = eventId + (dateStr ? '->' + dateStr : '');

  var currInfo = state[combinedId];
  if (currInfo.numberOfListeners > 1) {
    // Some listeners are still watching this pair, so decrease number
    // of listeners on a new copy of the info
    var newInfo = Object.assign({}, currInfo);
    newInfo.numberOfListeners--;
    state[combinedId] = newInfo;
  } else {
    // Remove this date
    delete state[combinedId];
  }
};

module.exports = ScheduleEvents;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/reducers/ScheduleEvents.js
// module id = 1026
// module chunks = 0